/**
 * Copyright (C) IRT GmbH 2020
 */

var QS = require('hbbtv-lib/tools/query_string').get;

var EventEmitter = require('events');

var debug = QS("debug");

var msp_static = QS("mspstatic");
var msp_dataserver = "/mrsbr/v1.1/msp_data?contentId=";
var msp_static_location = "../msp_static/";

var timeout = 2000;

var checkMaterialJSON = require("./check-material-json")(debug);

/**
 * @typedef DVBService
 * @property {number} onid Original Network Id
 * @property {number} tsid Transport Stream Id
 * @property {number} sid Service Id
 */

/**
 * Retrieves current MSP data for a DVB Service and periodically checks for updates.
 *
 * In case of success an event 'material_update' is emitted.
 *
 * In case of failure an event 'error' is emitted with a string as parameter, which is either NOTFOUND or TIMEOUT. There will be no retries after NOTFOUND event.
 *
 * If static data is requested data is received only once, in live use the server is polled regularely and 'material_update' is emitted if
 * the timestamp field changes.
 *
 * @param {DVBService} svc an object with onid, tsid, sid
 * @param {number} interval optional time interval for polling material data, only used when mspstatic URL param is not set.
 *
 * @returns {import('events').EventEmitter} event emitter with events "material_update" and "error".
 */
module.exports = function (svc, interval) {
    var emitter = new EventEmitter();

    function log(text) {
        emitter.emit("debug", "materialResolver.js: " + text);
    }

    var msp_location = msp_static ? msp_static_location + msp_static : msp_dataserver + svc.onid + "." + svc.tsid + "." +svc.sid;
    log("Get material for " + svc.sid + " from " + msp_location);

    /**
     * @type {string} the trigger timestamp of the most recent material.
     */
    var ts_trigger = null;

    function retrieveData () {
        //log('Check for material update for ' + svc.sid);
        var xhr = new XMLHttpRequest();
        xhr.open("GET", msp_location, true);

        xhr.responseType = "json";
        xhr.onload = function (e) {
            if (xhr.status == 200) {
                var material = null;
                if (e.target.responseType === 'json') {
                    material = xhr.response;
                } else {
                    log("Response type json not supported. Parsing with JSON.parse.");
                    material = JSON.parse(xhr.responseText);
                }

                if (material.timestamp !== ts_trigger) {
                    ts_trigger = material.timestamp;
                    emitter.emit('material_update', checkMaterialJSON(material));
                    //log("Material updated for " + svc.sid);
                }
                if (interval) {
                    setTimeout(retrieveData, interval);
                }
            } else {
                //log("Material not found for " + svc.sid);
                emitter.emit('error', "NOTFOUND");
            }
        };

        xhr.timeout = timeout;

        xhr.ontimeout = function () {
            log("Request timed out for " + svc.sid);
            xhr.abort();

            emitter.emit('error', "TIMEOUT");

            setTimeout(retrieveData, interval);
        };
        xhr.send();
    }

    retrieveData();

    return emitter;
};
